const $ = jQuery.noConflict();

const givingForm = {
    init() {
        const inputs = document.querySelectorAll('.block-content-form__right .gfield input, .block-content-form__right .gfield textarea');
        const textareas = document.querySelectorAll('.block-content-form__right .gfield textarea');
        const selects = $('.block-content-form__right select');

        if (inputs) {
            [...inputs].forEach(el => {
                el.addEventListener('focus', (e) => {
                    givingForm.checkInputs(e, true);
                });
                el.addEventListener('focusout', (e) => {
                    givingForm.checkInputs(e);
                });
            });
        }

        if (textareas) {
            [...textareas].forEach(el => {
                el.setAttribute('rows', '0');
                el.addEventListener('input', (e) => {
                    e.target.style.height = 'auto';
                    e.target.style.height = e.target.scrollHeight + 'px';
                }, false);
            });
        }

        if (selects.length) {
            selects.on('change.select2', (e) => {
                if ( e.target.value.length ) {
                    selects.parents('.gfield').addClass('filled')
                } else {
                    selects.parents('.gfield').removeClass('filled')
                }
            });
        }
    },
    checkInputs(event, focus = false) {
        const el = event.target;
        if (el.value || focus) {
            el.parentElement.parentElement.classList.add('filled');
        } else {
            el.parentElement.parentElement.classList.remove('filled');
        }
    },
}

export default givingForm;